import BaseTable, { AutoResizer, ColumnShape } from "react-base-table"

import OverlayLoader from "components/Shared/OverlayLoader/OverlayLoader"

interface DataTableProps {
  rowKey: string
  data: any[]
  columns: ColumnShape<any>[] | undefined
  isFetching?: boolean
}

export default function DataTable({ rowKey, data, columns, isFetching }: DataTableProps) {
  return (
    <div className="relative">
      <div className="h-full min-h-[50vh] mt-3">
        <AutoResizer>
          {({ width, height }) => (
            <BaseTable
              data={data}
              width={width}
              height={height}
              rowKey={rowKey}
              className="custom-table"
              rowHeight={38}
              headerHeight={45}
              columns={columns}
              emptyRenderer={() => <p>No records to display</p>}
            />
          )}
        </AutoResizer>
      </div>
      <OverlayLoader active={isFetching} />
    </div>
  )
}
